module.exports = __webpack_public_path__ + "img/door4.5fd24c48.gif";